import React from 'react';
import { Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GridLayout from '../components/layout/GridLayout';
import Menu from '../components/layout/Menu';
import Card from '../components/ui/Card';

interface QAPageProps {
  isMenuOpen?: boolean;
}

export default function QAPage({ isMenuOpen = false }: QAPageProps) {
  return (
    <GridLayout
      isMenuOpen={isMenuOpen}
      left={<Menu />}
      main={
        <Card>
          {/* Unified Brand Title */}
          <Typography variant="h4" sx={{ color: '#34de9aab', fontWeight: 'bold', mb: 3 }}>
            Q & A
          </Typography>
          
          <Accordion elevation={0} sx={{ border: '1px solid #eee', mb: 1, borderRadius: '8px !important' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: 'bold' }}>How do I connect my IoT device?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2">
                Go to My Page {">"} Settings {">"} Devices and follow the pairing instructions.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion elevation={0} sx={{ border: '1px solid #eee', borderRadius: '8px !important' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: 'bold' }}>Can I cancel my booking?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2">
                Yes, you can cancel up to 24 hours before the session starts via the Booking page.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Card>
      }
      right={
        <Card>
          <Typography variant="h6" sx={{ color: '#34de9aab', mb: 1 }}>Support</Typography>
          <Typography variant="body2">Contact: info@heremaimai.com</Typography>
          <Box component="img" src="/images/mascot.png" alt="Mascot" sx={{ width: '100%', mt: 2, opacity: 0.8 }} />
        </Card>
      }
    />
  );
}